var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgDepatu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 723.899,
    height: 730.262,
    viewBox: "0 0 723.899 730.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M986.365,604.6q.674-94.553-66.206-161.165-66.729-66.541-162.148-66.448-94.4-.6-161.951,67.061L403.539,637.321v93.731L642.956,490.729Q690.524,443.053,759,442.03q67.507-.122,115.306,47.449c31.893,31.634,47.9,70.136,47.994,115.132q-.825,68.537-48.4,116.23L638.984,956.669h50.584c14.528,0,28.769-.613,42.764-1.607L919.968,766.724Q987.365,698.977,986.365,604.6Z",
    transform: "translate(-403.539 -226.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M512.389,445.731,403.539,555.019v92.02L558.384,491.625q87.47-87.838,212.164-88.005Q895.391,403.411,983,490.8q88.661,88.115,88.835,212.969Q1071.2,827.65,983.813,915.4L857.372,1042.338c165.226-53.862,270.066-187.461,270.066-348.695v-2.167c0-147.332-87.554-270.512-228.715-331.349Q839.166,338.1,770.437,337.743,618.761,338.952,512.389,445.731Z",
    transform: "translate(-403.539 -337.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M855.446,508.851c.054-26.669-9.647-49.418-28.746-68.451q-28.608-28.583-69.318-29.29-40.718.839-69.264,29.563L403.539,726.356v92.008L734.063,486.536c15.653-15.567,31.19-15.752,46.889-.161q22.49,22.535-.795,46.021L453.974,859.84h93.332L826.961,579.06C846,559.956,855.615,536.568,855.446,508.851Z",
    transform: "translate(-403.539 -129.578)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDepatu);
export default __webpack_public_path__ + "static/media/bgDepatu.8093b91aacace50cbd6c78bcea6d3f04.svg";
export { ForwardRef as ReactComponent };